/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterFieldMappingAddPost } from '../fn/field-mapping/api-master-field-mapping-add-post';
import { ApiMasterFieldMappingAddPost$Params } from '../fn/field-mapping/api-master-field-mapping-add-post';
import { apiMasterFieldMappingDeleteGet } from '../fn/field-mapping/api-master-field-mapping-delete-get';
import { ApiMasterFieldMappingDeleteGet$Params } from '../fn/field-mapping/api-master-field-mapping-delete-get';
import { apiMasterFieldMappingEditPost } from '../fn/field-mapping/api-master-field-mapping-edit-post';
import { ApiMasterFieldMappingEditPost$Params } from '../fn/field-mapping/api-master-field-mapping-edit-post';
import { apiMasterFieldMappingGetActiveGet } from '../fn/field-mapping/api-master-field-mapping-get-active-get';
import { ApiMasterFieldMappingGetActiveGet$Params } from '../fn/field-mapping/api-master-field-mapping-get-active-get';
import { apiMasterFieldMappingGetAllGet } from '../fn/field-mapping/api-master-field-mapping-get-all-get';
import { ApiMasterFieldMappingGetAllGet$Params } from '../fn/field-mapping/api-master-field-mapping-get-all-get';
import { FieldMapping } from '../models/field-mapping';
import { FieldMappingApiRespModel } from '../models/field-mapping-api-resp-model';
import { Int32ApiRespModel } from '../models/int-32-api-resp-model';

@Injectable({ providedIn: 'root' })
export class FieldMappingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterFieldMappingAddPost()` */
  static readonly ApiMasterFieldMappingAddPostPath = '/api/Master/FieldMapping/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldMappingAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterFieldMappingAddPost$Response(params?: ApiMasterFieldMappingAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FieldMappingApiRespModel>> {
    return apiMasterFieldMappingAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldMappingAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterFieldMappingAddPost(params?: ApiMasterFieldMappingAddPost$Params, context?: HttpContext): Observable<FieldMappingApiRespModel> {
    return this.apiMasterFieldMappingAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<FieldMappingApiRespModel>): FieldMappingApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterFieldMappingEditPost()` */
  static readonly ApiMasterFieldMappingEditPostPath = '/api/Master/FieldMapping/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldMappingEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterFieldMappingEditPost$Response(params?: ApiMasterFieldMappingEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FieldMappingApiRespModel>> {
    return apiMasterFieldMappingEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldMappingEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterFieldMappingEditPost(params?: ApiMasterFieldMappingEditPost$Params, context?: HttpContext): Observable<FieldMappingApiRespModel> {
    return this.apiMasterFieldMappingEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<FieldMappingApiRespModel>): FieldMappingApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterFieldMappingDeleteGet()` */
  static readonly ApiMasterFieldMappingDeleteGetPath = '/api/Master/FieldMapping/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldMappingDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldMappingDeleteGet$Response(params?: ApiMasterFieldMappingDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiRespModel>> {
    return apiMasterFieldMappingDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldMappingDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldMappingDeleteGet(params?: ApiMasterFieldMappingDeleteGet$Params, context?: HttpContext): Observable<Int32ApiRespModel> {
    return this.apiMasterFieldMappingDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Int32ApiRespModel>): Int32ApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterFieldMappingGetAllGet()` */
  static readonly ApiMasterFieldMappingGetAllGetPath = '/api/Master/FieldMapping/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldMappingGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldMappingGetAllGet$Response(params?: ApiMasterFieldMappingGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FieldMapping>>> {
    return apiMasterFieldMappingGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldMappingGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldMappingGetAllGet(params?: ApiMasterFieldMappingGetAllGet$Params, context?: HttpContext): Observable<Array<FieldMapping>> {
    return this.apiMasterFieldMappingGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FieldMapping>>): Array<FieldMapping> => r.body)
    );
  }

  /** Path part for operation `apiMasterFieldMappingGetActiveGet()` */
  static readonly ApiMasterFieldMappingGetActiveGetPath = '/api/Master/FieldMapping/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterFieldMappingGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldMappingGetActiveGet$Response(params?: ApiMasterFieldMappingGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FieldMapping>>> {
    return apiMasterFieldMappingGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterFieldMappingGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterFieldMappingGetActiveGet(params?: ApiMasterFieldMappingGetActiveGet$Params, context?: HttpContext): Observable<Array<FieldMapping>> {
    return this.apiMasterFieldMappingGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FieldMapping>>): Array<FieldMapping> => r.body)
    );
  }

}
